import packageInfo from '../../package.json';

export const environment = {
  production: false,
  /*url: 'https://serversaas.pruebasgt.com'*/
  // url: 'https://apis.agentedeprensa.com.pe'
  // url: 'https://adp-saas-2025-api.pruebasgt.com',
  url: 'https://adp-api.hub83.cloud',

  images: {
    DEFAULT_AVATAR_PATH: './assets/images/default-avatar.png',
    DEFAULT_NO_IMAGE: './assets/images/noimage.png',
    LOGOTYPE: './assets/images/logotype.png'
  },
  version: `${packageInfo.version}-test`,
};

